import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import LookupService from '../../services/LookupService';
import { MultiSelect } from 'primereact/multiselect';
import ImageUpload from '../../components/ImageUpload';
import {formatDate} from "../../utils/helper";

const PromoCodeForm = () => {
  
  const { id } = useParams();
  const navigate = useNavigate();
  // const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [isLoader, setIsLoader] = useState(false);
  const [isUsersLoading, setIsUsersLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("info");
  const [timings, setTimings] = useState([]);
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') ?? "offer";

  const [formData, setFormData] = useState({
    title: '',
    title_ar: '',
    description: '',
    description_ar: '',
    discount_type: 'Amount',
    discount: '',
    expiry_type: '',
    expiry_date: '',
    expiry_count: '',
    total_count: '',
    user_type: '',
    pos_id: '',
    image: '',
    type: type,
    policy_conditions:[],
    policy_conditions_ar:[],
    branches:[],
  });

  const handleConditionChange = (index, value, isArabic) => {
    if (isArabic) {
        const updatedConditions = [...formData.policy_conditions_ar];
        updatedConditions[index] = value;
        setFormData((prev) => ({ ...prev, policy_conditions_ar: updatedConditions }));
    } else {
        const updatedConditions = [...formData.policy_conditions];
        updatedConditions[index] = value;
        setFormData((prev) => ({ ...prev, policy_conditions: updatedConditions }));
    }
  };
  const addCondition = () => {
    setFormData((prev) => ({
        ...prev,
        policy_conditions: [...prev.policy_conditions, ''],
        policy_conditions_ar: [...prev.policy_conditions_ar, '']
    }));
  };

  const removeCondition = (index) => {
    setFormData((prev) => ({
        ...prev,
        policy_conditions: prev.policy_conditions.filter((_, i) => i !== index),
        policy_conditions_ar: prev.policy_conditions_ar.filter((_, i) => i !== index)
    }));
  };

  const handleTimeChange = (index, field, value) => {
    const updatedTimings = [...timings];
    updatedTimings[index][field] = field === "is_off" ? !updatedTimings[index][field] : value;
    setTimings(updatedTimings);
  };

  const updateTiming = async (event) => {
    event.preventDefault();
    setIsLoader(true);

    try {
      
      const response = await ApiService.request({
        method: 'POST',
        url: `promo_codes/updateTimings/${id || ''}`,
        data: {'timings':timings},
      });

      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        // navigate('/branches');
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.log(error);
      setIsLoader(false);
    }
  };




  useEffect(() => {
    if (id) {
      getSingleData();
    }
    getActiveBranches();
    getActiveItems();
  }, [id]);

  // users-list is the heaviest lookup (every notifiable user), so only load it if the form
  // actually needs it. Nothing renders it unless user_type is "Specific".
  useEffect(() => {
    if (formData.user_type === 'Specific' && users.length === 0) {
      getActiveUsers();
    }
  }, [formData.user_type]);


  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `promo_codes/${id}`, // Replace with your API endpoint
      });
      const data = response.data;

      if (data.status) {

        if (data.data.promo_code.expiry_type == "Date") {
          data.data.promo_code.expiry_date=formatDate(data.data.promo_code.expiry_date,'YYYY-MM-DD')
        }
        data.data.promo_code.items = data.data.promo_items.map(item => item?.item_id?._id);
        data.data.promo_code.branches = data.data.promo_branches.map(item => item?.branch_id?._id);
        data.data.promo_code.users = (data.data.promo_user_ids ?? []).map(String);

        setFormData(data.data.promo_code);
        setTimings(data.data.timings);

       
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const getActiveUsers = async () => {
    setIsUsersLoading(true);
    try {
      setUsers(await LookupService.get('users-list'));
    } catch (error) {
      console.error(error);
    } finally {
      setIsUsersLoading(false);
    }
  };

  const getActiveBranches = async () => {
    try {
      setBranches(await LookupService.get('branches-list'));
    } catch (error) {
      console.error(error);
    }
  };

  const getActiveItems = async () => {
    try {
      setItems(await LookupService.get('items-list'));
    } catch (error) {
      console.error(error);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleImageChange = (name, file) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };
 
 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
            data.append(key, formData[key]);
      });
      // console.log(data);

      const response = await ApiService.request({
        method: 'POST',
        url: `promo_codes/createOrUpdate/${id || ''}`, // Replace with your API endpoint
        data,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/promo_codes');
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Promo Code
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/promo_codes" className="text-muted text-hover-primary">Promo Codes</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
                
          <div className="card">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button  className={`nav-link fs-6 px-5 ${tab === "info" ? "active" : ""}`}
                        onClick={() => setTab("info")}
                  type="button"> <i className="bi bi-tags-fill fs-5"></i> Promo Info</button>
              </li>
              
              <li class="nav-item" role="presentation">
                <button className={`nav-link fs-6 px-5 ${tab === "events" ? "active" : ""}`}
                        onClick={() => setTab("events")}
                  type="button" ><i className="bi bi-clock-fill fs-5"></i> Timed Events</button>
              </li>
            </ul>


            {tab == "info" &&
              <div className="card-body pt-0">
                <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                  <div className="row g-9 my-3">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Title</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Promo Code Title"
                        required
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Title Arabic</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Promo Code Title Arabic"
                        required
                        name="title_ar"
                        value={formData.title_ar}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Promo Code</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Code"
                        required
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Promo Type</label>
                      <select  name="promo_type" value={formData.promo_type} onChange={handleChange}
                        className='form-select form-control-solid' required>
                        <option value="">Select Promo type</option>
                        <option value="offer">Offer</option>
                        <option value="promo_code">Promo Code</option>
                      </select>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Min Order (AED)</label>
                      <input
                        type="number" step="0.01"
                        className="form-control form-control-solid"
                        placeholder="Enter Min Order Amount"
                        required
                        name="min_order"
                        value={formData.min_order}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Max Order (AED)</label>
                      <input
                        type="number" step="0.01"
                        className="form-control form-control-solid"
                        placeholder="Enter Max Order Amount"
                        required
                        name="max_order"
                        value={formData.max_order}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Discount Type</label>
                      <select  name="discount_type" value={formData.discount_type} onChange={handleChange}
                        className='form-select form-control-solid' required>
                        <option value="">Select Type</option>
                        <option value="Amount">Amount</option>
                        <option value="Percentage">Percentage</option>
                      </select>
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Discount {formData.discount_type}</label>
                      {formData.discount_type==="Amount"?(
                        <span>(AED)</span>
                      ):(
                        <span>(%)</span>
                      )}
                      <input  type="number" step="0.01"
                        className="form-control form-control-solid"
                        placeholder="Enter Discount "
                        required
                        name="discount"
                        value={formData.discount}
                        onChange={handleChange}
                      />
                    </div>
                    {formData.discount_type === 'Percentage' && 
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Max Discount Cap </label>
                        <input  type="number" step="0.01"
                          className="form-control form-control-solid"
                          placeholder="Enter Discount Cap "
                          required
                          name="max_discount"
                          value={formData.max_discount}
                          onChange={handleChange}
                        />
                      </div>
                    }
                    
                  
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Expiry Type</label>
                      <select  name="expiry_type" value={formData.expiry_type} onChange={handleChange}
                        className='form-select form-control-solid' required>
                        <option value="">Select Expiry</option>
                        <option value="Date">Date</option>
                        <option value="Count">Count</option>
                      </select>
                    </div>

                    {formData.expiry_type === "Date"?(
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Expiry Date </label>
                        <input  type="date"
                          className="form-control form-control-solid"
                          placeholder="Enter Date "
                          required
                          name="expiry_date"
                          value={formData.expiry_date}
                          onChange={handleChange}
                        />
                      </div>
                    ):(
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Usage Count (Per Customer) </label>
                        <input  type="number"
                          className="form-control form-control-solid"
                          placeholder="Enter Count Times "
                          required
                          name="expiry_count"
                          value={formData.expiry_count}
                          onChange={handleChange}
                        />
                      </div>
                    )}

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Total Usage Count (Overall) </label>
                        <input  type="text"
                          className="form-control form-control-solid"
                          placeholder="Enter Total Count "
                          required
                          name="total_count"
                          value={formData.total_count}
                          onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> POS ID </label>
                        <input  type="text"
                          className="form-control form-control-solid"
                          placeholder="Enter POS ID "
                          required
                          name="pos_id"
                          value={formData.pos_id}
                          onChange={handleChange}
                        />
                    </div>
                  
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> User Type</label>
                        <select  name="user_type" value={formData.user_type} onChange={handleChange}
                          className='form-select form-control-solid' required>
                          <option value="">Select User Type</option>
                          <option value="All">All Users</option>
                          <option value="New">New Users (No Orders)</option>
                          <option value="Existing">Existing Users (Has Orders)</option>
                          <option value="Specific">Specific Users</option>
                        </select>
                    </div>

                    {formData.user_type === "Specific" &&
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Users</label>
                        
                        <MultiSelect value={formData.users} name='users' onChange={handleChange} options={users} optionLabel="name"
                          filter placeholder={isUsersLoading ? "Loading users..." : "Select Users"} maxSelectedLabels={3}  optionValue="_id"
                          disabled={isUsersLoading} loading={isUsersLoading} virtualScrollerOptions={{ itemSize: 38 }}
                        />
                      </div>
                    }

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Branch Type</label>
                        <select  name="branch_type" value={formData.branch_type} onChange={handleChange}
                          className='form-select form-control-solid' required>
                          <option value="">Select Branch Type</option>
                          <option value="All">All Branches</option>
                          <option value="Specific">Specific Branches</option>
                        </select>
                    </div>

                    {formData.branch_type === "Specific" &&
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Branches</label>
                        
                        <MultiSelect value={formData.branches} name='branches' onChange={handleChange} options={branches} optionLabel="name" 
                          filter placeholder="Select Branches" maxSelectedLabels={3}  optionValue="_id"
                        />
                      </div>
                    }

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Menu Item</label>
                        <select  name="item_type" value={formData.item_type} onChange={handleChange}
                          className='form-select form-control-solid' required>
                          <option value="">Select Menu Item Type</option>
                          <option value="All">All Items</option>
                          <option value="Specific">Specific Items</option>
                        </select>
                    </div>

                    {formData.item_type === "Specific" &&
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2"> Menu Items</label>
                        
                        <MultiSelect value={formData.items} name='items' onChange={handleChange} options={items} optionLabel="title" 
                          filter placeholder="Select Items" maxSelectedLabels={3}  optionValue="_id"
                        />
                      </div>
                    }

                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Eligible for Delivery</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox"  
                          checked={formData.is_delivery === true} onChange={(e) => setFormData({ ...formData, is_delivery: e.target.checked })}
                            name="is_delivery" id="flexSwitchCheckChecked" />
                      </div>
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Eligible for Pickup</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={formData.is_pickup === true} onChange={(e) => setFormData({ ...formData, is_pickup: e.target.checked })}
                           name="is_pickup" id="flexSwitchCheckChecked" />
                      </div>
                    </div>

                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Order Channel (Web)</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={formData.is_web === true} onChange={(e) => setFormData({ ...formData, is_web: e.target.checked })}
                           name="is_web" id="flexSwitchCheckChecked" />
                      </div>
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Order Channel (App)</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={formData.is_app === true} onChange={(e) => setFormData({ ...formData, is_app: e.target.checked })}
                           name="is_app" id="flexSwitchCheckChecked" />
                      </div>
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className=" fs-6 fw-semibold mb-2">Image</label>
                      <ImageUpload name="image" onImageChange={handleImageChange} defaultPreviewUrl={formData.image} />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Description</label>
                      <textarea name="description"  rows="3"
                        value={formData.description}
                        onChange={handleChange} 
                        className="form-control form-control-solid"
                        placeholder="Enter Promo Code Description">
                      </textarea>
                    
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Description Arabic</label>
                      <textarea name="description_ar" rows="3"
                        value={formData.description_ar}
                        onChange={handleChange} 
                        className="form-control form-control-solid"
                        placeholder="Enter Promo Code Description Arabic">
                      </textarea>
                    </div>
                   
                  </div>

                  <div className="row g-9 my-3">
                    <div className="text-center">
                      <Link to={`/promo_codes`} className="btn btn-light me-3">Back</Link>
                      <button duration="submit" className="btn btn-base" disabled={isLoader}>
                        <span className="indicator-label">{isLoader ? <Loader size="20" color="black" text="Submitting" /> : ('Submit')}</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            }
            {tab === "events" && (
              <div class="tab-pane card-body fade show active">
                <div className="table-responsive mt-5 w-lg-75">
                  <form encType="multipart/form-data" method="POST" className="form fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={updateTiming}>

                    <table className="table align-middle table-striped bitem fs-6">
                      <tbody>
                        <tr>
                          <th className="px-3 fw-semibold">Day</th>
                          <th className="px-3 fw-semibold">Start Time</th>
                          <th className="px-3 fw-semibold">End Time</th>
                          <th className="px-3 fw-semibold">Remove</th>
                        </tr>
                        {timings.map((timing, index) => (
                          <tr key={timing.day} className="border">
                            <td className="p-3 fw-bold">
                              {timing.day}
                              <input type="hidden" name="days[]" value={timing.day} />
                            </td>
                            <td>
                              <input
                                type="time"
                                name={`start_time[${timing.day}]`}
                                className="form-control border"
                                value={timing.start_time}
                                onChange={(e) => handleTimeChange(index, "start_time", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="time"
                                name={`end_time[${timing.day}]`}
                                className="form-control border"
                                value={timing.end_time}
                                onChange={(e) => handleTimeChange(index, "end_time", e.target.value)}
                              />
                            </td>
                            <td>
                              <button 
                                type="button" 
                                className="btn btn-sm btn-secondary" 
                                onClick={() => {
                                  handleTimeChange(index, "start_time", "");
                                  handleTimeChange(index, "end_time", "");
                                }}
                              > 
                                <i className="bi bi-trash"></i>  
                              </button>
                            </td>
                          </tr>
                        ))}

                      
                      </tbody>
                    </table>
                    <div className="text-center mb-3">
                      <button type="button" className="btn btn-light me-3" onClick={() => navigate('/branches')}>
                        Back
                      </button>
                      <button type="submit" className="btn btn-base" disabled={isLoader || !id}>
                        <span className="indicator-label" hidden={isLoader}>Update</span>
                        {isLoader && <Loader size={20} text="Updating" />}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}


          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoCodeForm;
